module.exports = __webpack_public_path__ + "img/Urdu.9101f91a.svg";